var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask"},[_c('div',{staticClass:"slideContainer"},[_c('slide-verify',{attrs:{"slider-text":"向右滑动验证"},on:{"success":_vm.onSuccess,"fail":_vm.onFail,"refresh":_vm.onRefresh,"fulfilled":_vm.onFulfilled}}),_c('div',{staticStyle:{"margin-top":"15px"}},[_vm._v(" "+_vm._s(_vm.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }